export default "__VITE_ASSET__CGxltayL__"